"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PreviewContext", {
  enumerable: true,
  get: function get() {
    return _reactDndPreview.Context;
  }
});
exports.Preview = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactDndPreview = _interopRequireWildcard(require("react-dnd-preview"));

var _common = require("../common");

var _DndProvider = require("./DndProvider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Preview = function Preview(props) {
  var enabled = (0, _common.useObservePreviews)();
  var portal = (0, _react.useContext)(_DndProvider.PreviewPortalContext);

  if (!enabled) {
    return null;
  }

  var result = /*#__PURE__*/_react.default.createElement(_reactDndPreview.default, props);

  if (portal) {
    return /*#__PURE__*/_reactDom.default.createPortal(result, portal);
  }

  return result;
};

exports.Preview = Preview;
Preview.Context = _reactDndPreview.Context;
Preview.propTypes = _reactDndPreview.default.propTypes;